export default __webpack_public_path__ + "static/media/bgError.ebc0eca8.png";